import React, {
  useEffect,
  useState,
  useContext,
  useLayoutEffect,
  useRef,
  Fragment,

} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Modal as AntModal } from "antd";
import Sidebar from "../Sidebar";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { isValidEmail, maxFileUploadSize, processType, raiseIssueSteps } from "../../utils/constant";
import moment from "moment";
import Switch from "react-input-switch";
import downloadImage from "../../images/download.svg";
import tickwhite from "../../images/tick-white.svg";
import deleteImageEnabled from "../../images/reddelete.svg";
import starsIcon from "../../images/stars.svg";
import starsIconGrey from "../../images/stars-grey.svg";
import closeImg from "../../images/close.svg";
import {
  Row,
  Col,
  Accordion,
  Button,
  Modal,
  Tabs,
  Tab,
  Form,
  FormControl,
} from "react-bootstrap";
import ChatButton from "../../Chat/ChatButton";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import {
  getMaterial,
  getPurchaseOrderRelatedIssueUser,
  getQualityRelatedIssueUser,
} from "../../utils/actions/allactions";
import {
  getPurchaseOrderById,
  updatePurchaseOrderRating,
  updatePOAdminComment,
  handleSubmitFeedBackForPO,
  updateDeliveryDateForPO,
  updateShippedDateForPO,
  updateDeliveryLinkForPO,
  closePurchaseOrder,
  handlePartsDataUpdateForPO,
  shippingAddressUpdateForPO,
  submitRaiseIssueForPO,
  getIssuesForPO,
  handleIssueCloseForPO,
  handlePOCancel,
  handlePoDocInfoUpdate,
  handleQRInformationUpdateForPO,
  handleQualityDocOrderUpdateForPO,
  handleConsignMentPictureUploadForPO,
  handleDeleteDraftOrder,
  handleApprovePurchaseOrder,
  handleAcceptPO,
  handleSendEmailConfirmation,
  downloadPurchaseOrderPdf,
  updatePONotes,
  updateOrderChargesForPO,
  getBillsByPoId,
  createBillForPurchaseOrder,
  updatePurchaseOrderNumber,
  downloadBatchFileSupplier,
  updateExpectedShippingDates,
} from "../../utils/actions/supplierActions";
import downloadFileFromS3, {
  numberInputOnWheelPreventChange,
  currencyFormatter,
  extractURLAndEncodedFilename,
  capitalizedStatus,
} from "../../utils/helper";
import useDocumentTitle from "../../utils/useDocumentTitle";
import CaptchaModal from "../../components/CaptchaModal/CaptchaModal";
import { DeleteIcon, DownloadIcon, LucidLoader } from "../../components/Icons";

import MetaDataInfoCncComponent from "../../components/OfferRfqDetails/MetaDataInfoCncComponent";
import MetaDataInfoThreeDComponent from "../../components/OfferRfqDetails/MetaDataInfoThreeDComponent";
import { getAllMachineDataWithPopulation, getAllTechnology } from "../../utils/actions/adminActions";
import { getAllMaterialsList, getPresignedUrlForFile } from "../../api/helperapi/helperApi";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { useInstance } from "../../context/instance.context";
import ThreeDViewerComponent from "../../components/ViewerComponent/ThreeDViewerComponent";
import { createOrganizationAddress, deleteOrganizationAddress, getOrganizationAddresses } from "../../api/customer/masters/adminMastersApi";
import EmailModal from "../EmailModal/EmailModal";
import FileName from "../../components/FileNameWithDownloadAndDelete/FileNameWithDownloadAndDelete";
import { useUnsavedChanges } from "../../context/UnsavedChangesContext";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";
import PreviewAddressModal from "../../components/GenericAddressComponent/GenericPreviewAddressComponent";
import GenericAddressComponent from "../../components/GenericAddressComponent/GenericAddressComponent";
import PDFModalViewer from "../../components/PDFViewerModal/PDFModalViewer";
import EmailRecordModal from "../../components/EmailRecord/EmailRecordModal";
import WithDragAndDrop from "../../components/DragAndDrop/DragAndDropButton";

const PurchaseOrderDetails = () => {
  let navigate = useNavigate();
  useDocumentTitle("Purchase Order Details");
  const { organizationName, organizationAddress: orgAddress } = useInstance();

  useEffect(() => {
    if (orgAddress) {
      setOrganizationAddress(orgAddress);
    }
  }, [orgAddress]);


  const [isPoUpdated, setIsPoUpdated] = useState();
  let { _id } = useParams();
  const [purchaseOrder, setPurchaseOrder] = useState({});

  console.log("Supplier Data :", purchaseOrder?.supplierId);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qualityDocs, setQualityDocs] = useState([]);
  let token = localStorage.getItem("Token");
  let decode;
  const [isChanged, setIsChanged] = useState({
    shippingAddress: false,
    orderInfo: false,
    qualityDoc: false,
    consignmentPhoto: false,
    deliveryDetails: false,
    isIssueClosed: false,
    qRDetailsChanged: false,
    adminComment: false,
    chargesChanged: false,
    poDocInfo: false,
  });
  const [open, setOpen] = useState(null);
  const { setSelectedChatRefId, setChatType } = useContext(ChatRefContext);
  const [addresses, setAddresses] = useState([]);
  const [showAddAddressModal, setShowAddAddressModal] = useState();
  const [esdChangeModalVisible, setEsdChangeModalVisible] = useState(false);
  const [newExpectedShippingDate, setNewExpectedShippingDate] = useState("");
  const [isEsdChanged, setIsNewEsdChanged] = useState(false);

  const [organizationAddress, setOrganizationAddress] = useState({});
  const [isBatchFileDownloading, setIsBatchFileDownloading] = useState(false);
  const [showEmailRecord, setShowEmailRecord] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isPartsEditable, setIsPartsEditable] = useState([]);
  const [consignmentPhoto, setConsignmentPhoto] = useState([]);
  const [deliveryTrackingLink, setDeliveryTackingLink] = useState();
  const [isShippingChanged, setIsShippingChanged] = useState(false);
  const [isDeliveryChanged, setIsDeliveryChanged] = useState(false);
  const [isOrderClosed, setIsOrderClosed] = useState();
  const [raiseIssueModal, setRaiseIssueModal] = useState(false);
  const [raiseIssueStepCount, setRaiseIssueStepCount] = useState(0);
  const [partsWithIssue, setPartsWithIssue] = useState([]);
  const [isPartIssue, setIsPartIssue] = useState(true);
  const [qualityRelatedIssue, setQualityRelatedIssue] = useState([]);
  const [orderRelatedIssue, setOrderRelatedIssue] = useState([]);
  const [issueDescription, setIssueDescription] = useState("");
  const [issueFileAttachment, setIssueFileAttachment] = useState([]);
  const [allIssuesForOrder, setAllIssuesForOrder] = useState([]);
  const [orderIssue, setOrderIssue] = useState([]);
  const [key, setKey] = useState(0);
  const [showExpectedDateModal, setShowExpectedDateModal] = useState(false);
  const [esdModalForAcceptPO, setEsdModalForAcceptPO] = useState(false);
  const [expectedShippingDateSelected, setExpectedShippingDateSelected] =
    useState(null);
  const [esdChangeReason, setEsdChangeReason] = useState("");
  const [buttonText, setButtonText] = useState('');
  const [captchaCallback, setCaptchaCallback] = useState(() => { });
  const [loading, setLoading] = useState(true);
  const [isPoInfoChange, setIsPoInfoChanged] = useState(false);
  const [showSentEmailModal, setShowSentEmailModal] = useState(false);
  const [manualEmail, setManualEmail] = useState("");
  const [emailListToSend, setEmailListToSend] = useState([]);
  const [isSelectAllClicked, setIsSelectedAllClicked] = useState(false);
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });

  const handleSentEmailModalOpenClose = () => setShowSentEmailModal((pre) => !pre);

  useEffect(() => {

    (async () => {
      try {
        const response = await getOrganizationAddresses();
        if (response?.status) {
          console.log('Organizatin ::', organizationAddress);
          setAddresses(response.data);
        } else {
          toast.error("Failed to fetch organization addresses");
        }


      } catch (error) {
        console.log("Error :", error);
      }
    })()

  }, []);

  console.log("Email List :", emailListToSend);
  const handleCheckboxChange = (email) => {

    setEmailListToSend((prevList) => {
      const updatedList = prevList.includes(email)
        ? prevList.filter((item) => item !== email)
        : [...prevList, email];


      return updatedList;
    });
  };
  const handleAddEmail = () => {
    if (isValidEmail(manualEmail)) {
      setEmailListToSend([manualEmail]);
      setIsSelectedAllClicked(false);
      setManualEmail("");
      handleSentEmailModalOpenClose();
      setShowCaptchaModal(true);
      setCaptchaCallback(() => () => handleSendEmailConfirmationClick());
      setButtonText("Send email");
    }
  };
  const [poNotes, setPoNotes] = useState(
    `Terms & Conditions
Please read these terms and conditions carefully you are deemed to have understood and agreed to all the terms and conditions
contained herein.
1. Supplier to acknowledge receipt of orders, completion of order will be regarded as acceptance of purchasers conditions.
2. All merchandise on this order is subject to purchasers inspection with right of rejection thereafter irrespective of prior payment.
3. Merchandise rejected will be returned to supplier at suppliers expense, no replacement will be made unless so authorized by purchaser.
4. ${organizationName} expect their suppliers to comply with applicable environmental, health and safety laws and regulations.
5. Special clause : In the instance of goods being shipped on wooden pallets or crates to the ship location, no fumigated pallet or crates are accepted. We only accept heated treated wood and same must be stamped on the pallet or crate.
6. Suppliers fulfilling purchase orders shall make no changes in process or composition of the material without prior notification from ${organizationName}.
7. Terms of payment are 60 days or as otherwise agreed.
8. In the event that a delivery date falls on a Saturday, Sunday or bank holiday, please ensure delivery occurs by the previous Friday morning as there may be no receiving facility available at the weekends.`
  );
  const handleSentEmailClickInModal = async () => {
    if (emailListToSend.length == 0) {
      await new Promise((resolve) => {
        AntModal.error({
          title: 'Error',
          content: 'Please select at least one email address',
          onOk: () => resolve(),
        });
      });

      return;
    }
    handleSentEmailModalOpenClose();
    setShowCaptchaModal(true);
    setButtonText('Send email');
    setCaptchaCallback(() => () => handleSendEmailConfirmationClick());

  }




  const [qrCodeLink, setQrCodeLink] = useState(false);
  const [isSendEmailInProgress, setIsSendEmailInProgress] = useState(false);

  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [billsForPurchaseOrder, setBillsForPurchaseOrder] = useState([]);
  const [emailListToSent, setEmailListToSent] = useState([]);
  const [billPartsData, setBillPartsData] = useState({});
  const [availableQtyArr, setAvailableQtyArr] = useState({});
  const [billTotalAmount, setBillTotalAmount] = useState(0);
  const [billDocument, setBillDocument] = useState(null);
  const [supplierBillNumber, setSupplierBillNumber] = useState("");
  const [isCreateBillActive, setIsCreateBillActive] = useState(false);
  const [isPoNumberEditing, setIsPoNumberEditing] = useState(false);
  const poInputRef = useRef();
  const orderInformationRef = useRef();
  const [allCncMachineData, setAllCncMachineData] = useState(null);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [isAnyUnsavedChanges, setIsAnyUnsavedChange] = useState(false);
  const [fullMastersData, setFullMastersData] = useState({});

  const { setIsDirty } = useUnsavedChanges();
  useEffect(() => {
    setIsDirty(isAnyUnsavedChanges);
  }, [isAnyUnsavedChanges])
  const [gobalLoading, setLobalLoading] = useState(false);
  useEffect(() => {
    Promise.all([
      getAllTechnology(),
      getAllMachineDataWithPopulation(),
      getAllMaterialsList()
    ])
      .then(([technologyRes, machineRes, materialRes]) => {
        setMasterThreeDTechnologyData(technologyRes.data);
        setAllCncMachineData(machineRes.data);
        setFullMastersData(materialRes);
      })
      .catch(err => {
        console.log("Error while fetching master data", err);
      });
  }, []);



  const ErrorCheckHOF = (callback) => {
    return (item) => {
      if (isAnyUnsavedChanges) {
        toast.error("There are unsaved changes. Please save them to continue.");
        return;
      }
      callback(item);
    }
  };




  useEffect(() => {
    setLoading(true);
    let billForPoArr = [...billsForPurchaseOrder];
    billForPoArr = billForPoArr.filter((item) => !item.isRejected);
    let localAvailableQtyData = {};
    purchaseOrder?.supplierRfqOfferId?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem._id] = lineItem.qty;
    });
    if (billForPoArr.length > 0) {
      billForPoArr.forEach((item) => {
        item?.partsData?.forEach((lineItem) => {
          localAvailableQtyData[lineItem.partItemId] =
            localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
        });
      });
    }

    setAvailableQtyArr(localAvailableQtyData);
    setLoading(false);
  }, [billsForPurchaseOrder]);

  const handleCloseESDChangeModal = () => {
    setEsdChangeModalVisible(false);
    setIsNewEsdChanged(false);
  };

  const handleUpdateESD = async (date) => {
    // Perform ESD update logic here
    console.log("New ESD submitted:", date);
    console.log("New ESD Reason:", esdChangeReason);
    try {
      let data = {
        expectedShippingDate: date,
        id: purchaseOrder._id,
        reasonToChange: esdChangeReason,
      };
      const response = await updateExpectedShippingDates(token, data);
      if (response.status) {
        toast.success("Expected Shipping date updated successfully");
        setShowExpectedDateModal(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        setPurchaseOrder((pre) => {
          return {
            ...pre,
            expectedShippingDates: response.data.expectedShippingDates,
          }
        });
      }
      handleCloseESDChangeModal();


    } catch (error) {
      console.log("Error ::", error);
      toast.error("Something went wrong while updating expected shipping date");
    }


  };


  const handeBillItemChange = (event, lineId) => {
    setIsAnyUnsavedChange(true);
    let localBillPartsData = { ...billPartsData };
    if (availableQtyArr[lineId] < parseInt(event.target.value)) {
      toast.error(
        "The invoice quantity cannot be more than order item quantity"
      );
      localBillPartsData[lineId] = 0;
    } else {
      localBillPartsData[lineId] = parseInt(event.target.value);
    }

    setBillPartsData(localBillPartsData);
    let localBilTotalAmount = 0;
    purchaseOrder?.supplierRfqOfferId?.partsData.forEach((item) => {
      localBilTotalAmount =
        localBilTotalAmount + (localBillPartsData[item._id] || 0) * item.price;
    });

    setBillTotalAmount(localBilTotalAmount);
  };

  const handleCancelCreateBill = () => {
    setIsCreateBillActive(false);
    setBillPartsData({});
    setBillTotalAmount(0);
    setSupplierBillNumber("");
    setBillDocument(null);
  };

  const handleCreateBill = async () => {
    setIsAnyUnsavedChange(false);
    try {
      if (purchaseOrder.status == "Draft") {
        toast.error("Cannot create bill for draft order.");
        return;
      }

      if (purchaseOrder.status == "Awaiting PO Acceptance") {
        toast.error("Order need to be accepted in order to create bill.");
        return;
      }

      if (!purchaseOrder?.purchaseOrderNumber) {
        toast.error("Purchase order number is not updated.");
        return;
      }

      if (billTotalAmount <= 0) {
        toast.error(
          "Please enter valid shipping details for parts. Bill amount cannot be zero."
        );
        return;
      }

      if (!billDocument) {
        toast.error("Please upload bill document");
        return;
      }

      if (!supplierBillNumber) {
        toast.error("Please enter supplier bill number");
        return;
      }

      let userResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Send for Approval',
          content: 'Are you sure you want to send these details for approval?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (!userResponse) {
        return;
      }
      setLoading(true);
      let formData = new FormData();
      formData.append("billPartsData", JSON.stringify(billPartsData));
      formData.append("billTotalAmount", billTotalAmount);
      formData.append("supplierBillNumber", supplierBillNumber);
      formData.append("poId", purchaseOrder?._id);
      formData.append("pORefId", purchaseOrder.pORefId);
      formData.append("supplierId", purchaseOrder.supplierId._id);
      formData.append("shippedDate", "");
      formData.append("deliveryTrackingLink", "");
      formData.append("shippingCarrier", "");
      formData.append("isNoQCDocChecked", false);
      formData.append("isNoConsignmentsChecked", false);
      formData.append("billQualityDocumentsData", JSON.stringify([]));
      formData.append("billDocument", billDocument);

      const createBillResponse = await createBillForPurchaseOrder(
        token,
        formData
      );

      if (createBillResponse.status) {
        toast.success("Bill created successfully and sent for approval.");
        setIsCreateBillActive(false);
        setBillTotalAmount(0);
        setBillDocument(null);
        setSupplierBillNumber("");
        setBillPartsData({});
        navigate(`/admin/bill-details/${createBillResponse.data._id}`);
      }
    } catch (err) {
      console.log("err", err);
      toast.error(
        err.response.data.message ||
        "Something went wrong while creating bill for purchase order"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNewBillClick = ErrorCheckHOF(() => {
    orderInformationRef.current.click();
    let isAllInvoiced = true;
    let availableQtyValuesArr = Object.values(availableQtyArr);
    availableQtyValuesArr.forEach((item) => {
      if (item > 0) {
        isAllInvoiced = false;
      }
    });

    if (!isAllInvoiced) {
      setIsCreateBillActive(true);
    } else {
      toast.error("All items for this order are already billed");
    }
  });

  const handleCloseCaptchaModal = () => {
    setShowCaptchaModal(false);
    setCaptchaCallback(() => () => { });
    setButtonText('');
  };
  const handleUpdatePONotes = async () => {
    try {
      let data = {
        orderId: purchaseOrder._id,
        poNotes,
      };

      const response = await updatePONotes(token, data);
      if (response.status) {
        toast.success(response.message);
        setPurchaseOrder({
          ...purchaseOrder,
          poNotes: response?.data?.poNotes,
        });
      }
    } catch (err) {
      console.log(
        "Error in admin quote 137 on: " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleCloseESDAcceptPOModal = () => setEsdModalForAcceptPO(false);

  const handleClose = () => setShowModal(false);


  console.log("")

  const showDrawer = (id) => {
    if (id.startsWith('S')) {
      if (id[1] == '-') {
        id = id.slice(2)
      }
      else {
        id = id.slice(1)
      }
    }
    setOpen(id);
    setSelectedChatRefId(id);
    setChatType("supplier");
  };

  const onClose = () => {
    setOpen(null);
    setSelectedChatRefId(null);
    setChatType(null);
  };

  useEffect(() => {
    handleDataFetch()
  }, []);

  const handleDataFetch = async () => {
    try {
      fetchOrdersDetails();
    } catch (err) {
      console.log('Error feching po data', err)
      toast.error("Error fetching PO data")
    } finally {

    }

  };



  useEffect(() => {
    if (purchaseOrder?.supplierRfqOfferId?.leadTime !== undefined) {
      const baseDate = purchaseOrder?.poAcceptanceDate
        ? moment(purchaseOrder.poAcceptanceDate)
        : moment();

      const calculatedDate = baseDate
        .add(purchaseOrder.supplierRfqOfferId.leadTime, "days")
        .format("YYYY-MM-DD"); // for input[type="date"]
      console.log("Calculated date ::", calculatedDate);

      setExpectedShippingDateSelected(calculatedDate);
    }
  }, [purchaseOrder]);


  const [selectedEmailListForSupplier, setSelectedEmailLIstForSupplier] = useState([]);
  const fetchOrdersDetails = async () => {
    setLobalLoading(true);

    try {
      // 1) First API – must be done before all others
      const purchaseOrderData = await getPurchaseOrderById(_id, token);

      setPurchaseOrder(purchaseOrderData.data);
      setIsPoUpdated(purchaseOrderData.data?.purchaseOrderNumber);

      setSelectedEmailLIstForSupplier(
        purchaseOrderData?.data?.supplierId?.emailList || []
      );

      const date = purchaseOrderData.data?.expectedShippingDates?.reduce(
        (maxObj, currentObj) =>
          currentObj?.updatedDate > maxObj?.updatedDate ? currentObj : maxObj,
        null
      )?.updateValue;

      if (date) {
        setNewExpectedShippingDate(moment(date).format("YYYY-MM-DD"));
      }

      setQrCodeLink(
        `${window.location.origin}/view-order-details/${purchaseOrderData.data.salesOrderId}`
      );
      setPoNotes(purchaseOrderData?.data?.poNotes || poNotes);

      setDeliveryTackingLink(purchaseOrderData.data.deliveryTrackingLink);
      setIsOrderClosed(purchaseOrderData.data.isCompleted);

      setPartsWithIssue(purchaseOrderData.data.supplierRfqOfferId?.partsData);
      setIsPartsEditable(
        new Array(
          purchaseOrderData.data.supplierRfqOfferId?.partsData?.length
        ).fill(0)
      );

      setQualityDocs(purchaseOrderData.data.qualityDocuments);
      setConsignmentPhoto(purchaseOrderData.data.consignmentPhoto);
      setLobalLoading(false);
      const [
        poRelatedIssueResponse,
        qualityRelatedIssueResponse,
        allIssue,
        billsResponse,
      ] = await Promise.all([
        getPurchaseOrderRelatedIssueUser(token),
        getQualityRelatedIssueUser(token),
        getIssuesForPO(token),
        getBillsByPoId(token, purchaseOrderData.data._id),
      ]);

      // 3) Set secondary API data
      setOrderRelatedIssue(poRelatedIssueResponse.data.data);
      setQualityRelatedIssue(qualityRelatedIssueResponse.data.data);
      setBillsForPurchaseOrder(billsResponse.data);

      const localOrderIssues = allIssue.data.filter(
        (item) => item?.orderId === _id
      );

      if (localOrderIssues.length > 0) {
        setAllIssuesForOrder(localOrderIssues);
        setOrderIssue(localOrderIssues[localOrderIssues.length - 1]);
        setKey(localOrderIssues.length - 1);
      }
    } catch (err) {
      console.log(
        "Error fetching purchase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error("Something went wrong.");
    } finally {
      setLobalLoading(false);
    }
  };




  const handleOrderAdminCommentUpdate = async () => {
    if (isChanged.adminComment) {
      let data = {
        orderId: purchaseOrder._id,
        adminComment: purchaseOrder.adminComment,
      };
      const response = await updatePOAdminComment(data);
      if (response.status) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    }
  };

  const handleChangeAddress = () => {
    setShowModal(true);
  };

  const handleBack = async () => {
    const userResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Confirm Navigation',
        content: 'Unsaved information will be lost, are you sure you want to go back?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (userResponse) {
      navigate(-1);
    }
    return;
  };

  const handleQualityDocUpdate = async () => {
    let formData = new FormData();
    for (let i = 0; i < qualityDocs.length; i++) {
      if (
        !(!qualityDocs[i].file?.filename || !qualityDocs[i].file?.name) ||
        !qualityDocs[i].name
      ) {
        return false;
      }
      formData.append("fileToUpload", qualityDocs[i].file);
    }
    formData.append("qualityDoc", JSON.stringify(qualityDocs));
    formData.append("orderId", purchaseOrder._id);
    const updateOrder = await handleQualityDocOrderUpdateForPO(formData, token);
    return updateOrder;
  };

  const handleItemFieldEdit = (event, index, field) => {
    const value = event.target.value;
    if (value.includes('.') || value.includes(',')) {
      toast.error("decimal values is not allowed ");
    }
    setIsAnyUnsavedChange(true);
    let localQuoteData = purchaseOrder.supplierRfqOfferId;
    let localTotalAmount = purchaseOrder.totalAmount;
    if (field === "qty") {
      localQuoteData.partsData[index].qty = event.target.value;
    } else if (field === "price") {
      localQuoteData.partsData[index].price = event.target.value;
    } else if (field === "partNotes") {
      localQuoteData.partsData[index].partNotes = event.target.value;
    } else if (field === "description") {
      localQuoteData.partsData[index].description = event.target.value;
    }
    localTotalAmount = localQuoteData.partsData.reduce((acc, item) => {
      return acc + item.price * item.qty;
    }, 0);
    setPurchaseOrder({
      ...purchaseOrder,
      rfqOfferId: localQuoteData,
      totalAmount: localTotalAmount,
    });
    setIsChanged({ isChanged, orderInfo: true });
  };

  console.log("Expected shipping date ::", newExpectedShippingDate);

  const handleDeleteItemFromOrder = (index) => {
    console.log("Removing Item At Index ::", index);
    if (purchaseOrder?.supplierRfqOfferId?.partsData?.length == 1) {
      toast.error("Cannot delete last line item from order.");
      return;
    }
    if (isPartsEditable[index]) {
      let localQuoteData = purchaseOrder.supplierRfqOfferId;
      if (purchaseOrder?.supplierRfqOfferId?.partsData?.length == 1) {
        toast.error("Cannot delete all lines from this order.");
        return;
      }
      let localTotalAmount = purchaseOrder.totalAmount;
      localQuoteData.partsData.splice(index, 1);
      localTotalAmount = localQuoteData.partsData.reduce((acc, item) => {
        return acc + item.price * item.qty;
      }, 0);
      setPurchaseOrder({
        ...purchaseOrder,
        rfqOfferId: localQuoteData,
        totalAmount: localTotalAmount,
      });
      let localIsPartsEditable = isPartsEditable;
      localIsPartsEditable.splice(index, 1);
      setIsPartsEditable(localIsPartsEditable);
    }
    setIsChanged({ isChanged, orderInfo: true });
  };

  const handleEditableField = (index) => {
    if (billsForPurchaseOrder.length > 0) {
      toast.error(
        "Bills for order is already created. Cannot edit at this stage."
      );
      return;
    }
    let localIsPartsEditable = [...isPartsEditable];
    if (localIsPartsEditable[index] === 0) {
      localIsPartsEditable[index] = 1;
    } else {
      localIsPartsEditable[index] = 0;
    }
    setIsPartsEditable([...localIsPartsEditable]);
  };

  const handleUpdateConsignmentPhoto = async () => {
    let formData = new FormData();
    formData.append("orderId", purchaseOrder._id);
    formData.append("consignmentPhotoData", JSON.stringify(consignmentPhoto));
    for (let i = 0; i < consignmentPhoto.length; i++) {
      formData.append("consignmentPhoto", consignmentPhoto[i].file);
    }

    const updateOrder = await handleConsignMentPictureUploadForPO(
      formData,
      token
    );
  };

  const handleQRInformationChange = async () => {
    try {
      let formData = new FormData();
      formData.append("orderId", purchaseOrder._id);
      formData.append("qrCodeImage", purchaseOrder.qrCodeImage);
      formData.append("qrCodeDrawingFile", purchaseOrder.qrCodeDrawingFile);
      formData.append(
        "qrCodeImageData",
        JSON.stringify(purchaseOrder.qrCodeImage)
      );
      formData.append(
        "qrCodeDrawingFileData",
        JSON.stringify(purchaseOrder.qrCodeDrawingFile)
      );
      const updateOrder = await handleQRInformationUpdateForPO(formData, token);
    } catch (err) {
      console.log(
        "Error in 430 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleRating = async (rating, key) => {
    try {
      setPurchaseOrder({ ...purchaseOrder, [key]: rating });
      const response = await updatePurchaseOrderRating(token, {
        orderId: purchaseOrder?._id,
        [key]: rating,
      });
    } catch (err) {
      console.log(
        "Error in 444 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleFeedBackSubmit = async () => {
    const data = {
      orderId: purchaseOrder._id,
      feedBackComment: purchaseOrder.feedBackComment,
    };
    const response = await handleSubmitFeedBackForPO(token, data);
    if (response.status == 200) {
      toast.success("Feedback submitted successfully");
    } else {
      toast.error("Something went wrong while submitting feedback");
    }
  };

  const handleUpdateDeliveryDate = async () => {
    try {
      let data = {
        deliveryDate: purchaseOrder.deliveryDate,
        id: purchaseOrder._id,
      };
      await updateDeliveryDateForPO(token, data);
    } catch (err) {
      console.log(
        "Error in 530 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleUpdateShippedDate = async () => {
    let data = {
      shippedDate: purchaseOrder.shippedDate,
      id: purchaseOrder._id,
    };

    let response = await updateShippedDateForPO(token, data);
    if (!response.data.status) {
      toast.error("Something went wrong while updating shipping date.");
    }
  };

  const handleDeliveryTrackingLinkUpdate = async () => {
    let data = {
      deliveryTrackingLink: deliveryTrackingLink,
      orderId: purchaseOrder._id,
    };
    await updateDeliveryLinkForPO(token, data);
  };

  const handleComplete = async () => {
    let data = {
      orderId: purchaseOrder._id,
      deliveryComment: purchaseOrder.deliveryComment,
    };
    await closePurchaseOrder(token, data);
  };

  const handleOrderInfoUpdate = async () => {
    let data = {
      partsData: JSON.stringify(purchaseOrder.supplierRfqOfferId.partsData),
      orderId: purchaseOrder._id,
      totalAmount: purchaseOrder.totalAmount,
    };
    await handlePartsDataUpdateForPO(data, token);
  };


  const handleShippingAddressChange = async (shippingAddressData) => {
    try {
      let data = {
        orderId: purchaseOrder._id,
        shippingAddress: shippingAddressData,
      };
      let response = await shippingAddressUpdateForPO(token, data);
      if (response.status) {
        toast.success(response.message);
        setPurchaseOrder({
          ...purchaseOrder,
          shippingAddress: shippingAddressData,
        });
      }
    } catch (err) {
      console.log(
        "Error in 584 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };
  const addNewAddress = async (shippingAddress) => {
    try {
      setLoading(true);
      const data = { ...shippingAddress, type: "shipping" };
      const response = await createOrganizationAddress(data);
      if (response.status) {
        toast.success(response.message);
        let localAddresses = [...addresses, response.data];
        setAddresses(localAddresses);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error in adding new address", error);
      toast.error("Failed to add organization address");
    } finally {
      setLoading(false);
    }

  }

  const handleOrderUpdate = async () => {
    try {
      if (
        purchaseOrder.status == "refunded" ||
        purchaseOrder.status == "Cancelled"
      ) {
        toast.error("Order is already cancelled");
        return;
      }

      if (!purchaseOrder.purchaseOrderNumber) {
        toast.error("Purchase order number is mandatory.");
        return;
      }

      if (
        purchaseOrder.deliveryDate &&
        new Date(purchaseOrder?.shippedDate) >
        new Date(purchaseOrder.deliveryDate)
      ) {
        toast.error("Delivery date cannot come before shipped date");
        return;
      }

      //   if ( (order.shippedDate && !(moment.utc(order.shippedDate,'YYYY-MM-DD').isSameOrAfter(moment.utc(order.createdAt,'YYYY-MM-DD'))))
      //   || (order.expectedDelivery && !(moment.utc(order?.expectedDelivery,'YYYY-MM-DD').isSameOrAfter(moment.utc(order.createdAt,'YYYY-MM-DD'))))
      // )

      if (
        (purchaseOrder.shippedDate &&
          !moment
            .utc(purchaseOrder?.shippedDate, "YYYY-MM-DD")
            .isSameOrAfter(
              moment.utc(purchaseOrder.createdAt, "YYYY-MM-DD")
            )) ||
        (purchaseOrder.deliveryDate &&
          !moment
            .utc(purchaseOrder?.deliveryDate, "YYYY-MM-DD")
            .isSameOrAfter(moment.utc(purchaseOrder.createdAt, "YYYY-MM-DD")))
      ) {
        toast.error(
          "Shipped date and delivered date cannot be before order creation date."
        );
        return;
      }

      if (isOrderClosed) {
        toast.error("Order is already closed.");
        return;
      }
      setIsAnyUnsavedChange(false);

      if (isChanged.chargesChanged) {
        let data = {
          orderId: purchaseOrder._id,
          totalAmount: purchaseOrder?.totalAmount,
          adjustmentValue: purchaseOrder?.adjustmentValue,
        };

        await updateOrderChargesForPO(token, data);
      }
      if (isPoInfoChange) {
        handleNewPoNumberSubmit();
      }


      if (isChanged.qRDetailsChanged) {
        await handleQRInformationChange();
      }

      if (isChanged.orderInfo) {
        await handleOrderInfoUpdate();
      }

      if (isChanged.poDocInfo) {
        if (!purchaseOrder.purchaseOrderNumber) {
          toast.error("Purchase Order Number is required.");
          return;
        }

        let data = {
          id: purchaseOrder._id,
          purchaseOrderNumber: purchaseOrder.purchaseOrderNumber,
        };

        let poNumberResponse = await handlePoDocInfoUpdate(token, data);
        if (poNumberResponse.status) {
          setIsChanged({ ...isChanged, poDocInfo: false });
        }
      }

      if (isChanged.deliveryDetails) {
        if (purchaseOrder.status == "Draft") {
          toast.error("Cannot update delivery details for draft order.");
          return;
        }

        await handleDeliveryTrackingLinkUpdate();

        if (isShippingChanged) {
          if (!purchaseOrder.shippedDate) {
            if (
              purchaseOrder.deliveryDate ||
              purchaseOrder.isCompleted ||
              isOrderClosed
            ) {
              toast.error("Please enter shipped date");
              return;
            }
          }

          let adminResponse = await new Promise((resolve) => {
            AntModal.confirm({
              title: 'Confirm Update',
              content: 'Are you sure you want to update the order shipping date?',
              okText: 'Yes',
              cancelText: 'No',
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            });
          });
          if (adminResponse) {
            await handleUpdateShippedDate();
            setIsShippingChanged(false);
          }
        }

        if (isDeliveryChanged) {
          if (!purchaseOrder.shippedDate && purchaseOrder.deliveryDate) {
            await new Promise((resolve) => {
              AntModal.error({
                title: 'Error',
                content: 'Shipping date cannot be empty if delivery date is selected.',
                onOk: () => resolve(),
              });
            });

            return;
          }

          if (
            !purchaseOrder.deliveryDate &&
            (purchaseOrder.isCompleted || isOrderClosed)
          ) {
            toast.error("Please enter expected delivery details");
            return;
          }

          let adminResponse = await new Promise((resolve) => {
            AntModal.confirm({
              title: 'Confirm Delivery Date Update',
              content: 'Are you sure you want to update the order delivery date?',
              okText: 'Yes',
              cancelText: 'No',
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            });
          })
          if (adminResponse) {
            await handleUpdateDeliveryDate();
            setIsDeliveryChanged(false);
          }
        }
      }

      if (isChanged.qualityDoc) {
        if (purchaseOrder.status == "Draft") {
          toast.error("Cannot update quality documents for draft order.");
          return;
        }
        let response = await handleQualityDocUpdate();
        if (response === false || response?.response?.status === 500) {
          toast.error("Please enter valid quality document information");
          return;
        }
      }

      if (
        consignmentPhoto.length > 0 ||
        purchaseOrder.consignmentPhoto.length > 0 ||
        isChanged.consignmentPhoto === true
      ) {
        if (purchaseOrder.status == "Draft") {
          toast.error("Cannot update consignment photos for draft order.");
          return;
        }
        await handleUpdateConsignmentPhoto();
      }

      if (isChanged.isIssueClosed) {
        if (purchaseOrder.status == "Draft") {
          toast.error("Cannot close issue for draft order.");
          return;
        }
        let data = {
          orderId: orderIssue.orderId,
          issueId: orderIssue._id,
        };
        await handleIssueCloseForPO(token, data);
      }

      if (purchaseOrder.isCompleted && !isOrderClosed) {
        if (purchaseOrder.status == "Draft") {
          toast.error("Cannot close draft order.");
          return;
        }

        let adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm Close Order',
            content: 'Are you sure you want to close the order?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
        if (adminResponse) {
          await handleComplete();
        }
      }

      toast.success("Order updated successfully");
    } catch (err) {
      console.log(
        "Error in 744 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error("Something went wrong while updating the order");
    }
  };

  const handleRaiseIssueClose = () => {
    setRaiseIssueModal(false);
  };

  const handleRaiseIssueNext = async () => {
    if (raiseIssueStepCount == 2) {
      if (issueDescription == "" || issueDescription == false) {
        toast.error("Issue description is required.");
        return;
      }
      setRaiseIssueModal(false);
      let response = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Submit Issue',
          content: 'Are you sure you want to submit the issue?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (response) {
        handleSubmitIssue();
      }
    } else {
      let countOfSelectPartIssue = partsWithIssue?.reduce((acc, item) => {
        if (item.selected) {
          return acc + 1;
        } else {
          return acc;
        }
      }, 0);

      if (countOfSelectPartIssue === 0 && isPartIssue) {
        toast.error(
          "If there is no issue in any parts, kindly select the not a part issue option"
        );
        return;
      }

      setRaiseIssueStepCount(raiseIssueStepCount + 1);
    }
  };

  const handleRaiseIssueBack = () => {
    if (raiseIssueStepCount == 0) {
    } else {
      setRaiseIssueStepCount(raiseIssueStepCount - 1);
    }
  };

  const handleNotPartIssueSelect = () => {
    setIsPartIssue(!isPartIssue);
    if (isPartIssue) {
      partsWithIssue?.forEach((item) => {
        item.selected = false;
      });
    }
  };

  const handleSelectPartWithIssue = (index) => {
    if (!isPartIssue) {
      toast.error(
        'You cannot select any parts when you have selected the "Not a part issue. Purchase/ order related issue" checkbox '
      );
      return;
    }
    const localPartsWithIssue = [...partsWithIssue];
    localPartsWithIssue[index].selected = !localPartsWithIssue[index].selected;
    setPartsWithIssue(localPartsWithIssue);
  };
  const handleSelectAll = () => {
    console.log("Running Data :");
    if (!isSelectAllClicked) {
      setIsSelectedAllClicked(true);
      console.log("Data :", purchaseOrder?.supplierId?.emailList);
      if (Array.isArray(purchaseOrder?.supplierId?.emailList)) {
        const allEmail = purchaseOrder?.supplierId?.emailList;
        const updatedEmail = emailListToSend;
        allEmail.forEach((email) => {
          if (!updatedEmail.includes(email)) {
            updatedEmail.push(email);
          }
        });
        setEmailListToSend(updatedEmail);
      }

    }
    else {
      console.log("IsAllClicked :", isSelectAllClicked);
      setEmailListToSend([]);
      setIsSelectedAllClicked(false);
    }

  }

  const handleQualityRelatedIssueSelect = (index) => {
    const localQualityRelatedIssue = [...qualityRelatedIssue];
    localQualityRelatedIssue[index].selected =
      !localQualityRelatedIssue[index].selected;
    setQualityRelatedIssue(localQualityRelatedIssue);
  };

  const handlePORelatedIssueSelect = (index) => {
    const localPORelatedIssues = [...orderRelatedIssue];
    localPORelatedIssues[index].selected =
      !localPORelatedIssues[index].selected;
    setOrderRelatedIssue(localPORelatedIssues);
  };

  const handleIssueFileAttachmentAdd = (files) => {
    let localIssueAttachment = [...issueFileAttachment];
    const filesUploaded = Object.values(files);
    for (let i = 0; i < filesUploaded.length; i++) {
      localIssueAttachment.push(filesUploaded[i]);
    }
    setIssueFileAttachment(localIssueAttachment);
  };

  const handleDeleteIssueAttachment = (index) => {
    let localIssueAttachment = [...issueFileAttachment];
    localIssueAttachment.splice(index, 1);
    setIssueFileAttachment(localIssueAttachment);
  };

  console.log("Supplier offerRFQ :", purchaseOrder?.supplierRfqOfferId?.rfqOfferId);

  const handleSubmitIssue = async () => {
    let qualityRelatedIssueSelected = qualityRelatedIssue.filter(
      (item) => item.selected
    );
    let orderRelatedIssueSelected = orderRelatedIssue.filter(
      (item) => item.selected
    );
    let partsWithIssueSelected = partsWithIssue?.filter(
      (item) => item.selected
    );

    let formData = new FormData();
    formData.append("orderId", purchaseOrder?._id);
    formData.append(
      "qualityRelatedIssue",
      qualityRelatedIssueSelected.length > 0
        ? JSON.stringify(qualityRelatedIssueSelected)
        : ""
    );
    formData.append(
      "orderRelatedIssue",
      orderRelatedIssueSelected?.length > 0
        ? JSON.stringify(orderRelatedIssueSelected)
        : ""
    );
    formData.append("isPartIssue", isPartIssue);
    formData.append(
      "partsWithIssue",
      partsWithIssueSelected?.length > 0
        ? JSON.stringify(partsWithIssueSelected)
        : ""
    );
    formData.append("issueDescription", issueDescription);

    for (let i = 0; i < issueFileAttachment.length; i++) {
      formData.append("issueFileAttachment", issueFileAttachment[i]);
    }

    try {
      setRaiseIssueModal(false);
      let response = await submitRaiseIssueForPO(token, formData);
      if (response.status) {
        setAllIssuesForOrder([...allIssuesForOrder, response.data]);
      }

      if (response.statusCode === 200) {
        toast.success("Issue submitted successfully");
        setIsPartIssue(true);
        setIssueDescription("");
        setQualityRelatedIssue([]);
        setPartsWithIssue([]);
        setOrderRelatedIssue([]);
        setIssueFileAttachment([]);
        setRaiseIssueStepCount(0);
      }
    } catch (err) {
      console.log(
        "Error in 878 purcase order details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
      toast.error(
        "Something went wrong while submitting the issue.Please try again later"
      );
    }
  };

  const handleShowSelectedIssue = (key) => {
    setOrderIssue(allIssuesForOrder[key]);
  };

  const handleCancelPurchaseOrder = async () => {
    try {
      if (billsForPurchaseOrder && Array.isArray(billsForPurchaseOrder) && billsForPurchaseOrder.length) {
        //number of bills is non-zero so don't let user to cancel order
        toast.error('An order linked to one or more bills cannot be canceled.');
        return;
      }
      if (purchaseOrder.status == "Cancelled") {
        toast.error("Order is already cancelled");
        return;
      }
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Confirm Order Cancellation',
          content: `Are you sure you want to cancel the order ${purchaseOrder.pORefId}?`,
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) {
        return;
      }
      let cancelResponse = await handlePOCancel(token, {
        orderId: purchaseOrder._id,
      });
      if (cancelResponse.status) {
        setPurchaseOrder({ ...purchaseOrder, status: "Cancelled" });
        toast.success(cancelResponse.message);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleAcceptPOClick = ErrorCheckHOF(async () => {
    setEsdModalForAcceptPO(true);
  });

  const handleDeleteOrderClick = async () => {
    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Delete Draft Order',
        content: 'Are you sure you want to delete this draft order? Note: Date will be inaccessible and the RFQ will move to "In Progress" status.',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!adminResponse) {
      return;
    }
    let data = {
      purchaseOrderId: purchaseOrder._id,
    };
    const deletedResponse = await handleDeleteDraftOrder(data, token);
    if (deletedResponse.status) {
      toast.success(deletedResponse.message);
      navigate("/admin/purchase-orders");
    }
  };

  const handleChangeEDSClick = () => {
    setEsdModalForAcceptPO(true);
  }

  const handleApprovePOClick = ErrorCheckHOF(async () => {
    if (!purchaseOrder.purchaseOrderNumber) {
      toast.error(
        "Purchase order number is mandatory to use this functionality."
      );
      return;
    }

    if (purchaseOrder.purchaseOrderNumber && isChanged.poDocInfo) {
      toast.error("Please update order to use this functionality.");
      return;
    }
    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Approve Draft Order',
        content: 'Are you sure you want to approve this draft order? Once approved, this order will be sent to the Supplier Portal in "Awaiting PO Acceptance" state.',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!adminResponse) {
      return;
    }
    let data = {
      purchaseOrderId: purchaseOrder._id,
    };
    const approvedResponse = await handleApprovePurchaseOrder(data, token);
    if (approvedResponse.status) {
      toast.success(approvedResponse.message);
      fetchOrdersDetails();
    }
  });

  const handleProceedAcceptPOClick = async () => {
    try {
      if (!expectedShippingDateSelected) {
        toast.error("Please selected expected shipping date.");
        return;
      }

      let expectedShippingDateValue = null;
      if (
        !(
          moment(expectedShippingDateSelected).format("DD MMM YYYY") ==
          moment(Date.now())
            .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
            .format("DD MMM YYYY")
        )
      ) {
        if (!esdChangeReason) {
          toast.error(
            "Please enter reason to change the Expected Shipping date."
          );
          return;
        }
        expectedShippingDateValue = expectedShippingDateSelected;
      }

      let data = {
        orderId: purchaseOrder?._id,
        expectedShippingDate: expectedShippingDateValue,
        reasonToChange: esdChangeReason,
      };
      const response = await handleAcceptPO(token, data);
      if (response.data.status) {
        setPurchaseOrder(response.data.data);
        setEsdModalForAcceptPO(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        toast.success(response.data.message);
      } else {
        toast.error("Something went wrong while accepting PO");
      }
    } catch (err) {
      console.log("err", err.message);
      return;
    }
  };

  const handleSendEmailConfirmationClick = async (emails) => {
    try {
      setIsSendEmailInProgress(true);
      let adminResponse = true;
      if (purchaseOrder.isEmailConfirmationSent) {
        adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Resend Email Confirmation',
            content: 'The email confirmation for this order is already sent. Are you sure you want to send it again?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
      }

      if (!adminResponse) {
        setIsSendEmailInProgress(false);
      }

      if (adminResponse) {
        let data = {
          orderId: purchaseOrder?._id,
          emailListToSend: emails,
        };
        const response = await handleSendEmailConfirmation(token, data);

        if (response.status) {
          toast.success(response.message);
          const pOEmailRecord = response?.data?.pOEmailRecord || [];
          setPurchaseOrder({ ...purchaseOrder, isEmailConfirmationSent: true, pOEmailRecord });
          setIsSendEmailInProgress(false);
        }
      }
    } catch (err) {
      setIsSendEmailInProgress(false);
      console.log("error in purchase order details 1045", err);
    }
  };

  const handleDeleteAddress = async (address) => {
    const id = address._id;
    setShowModal(false);
    try {
      const adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Delete Address?',
          content: 'Are you sure you want to delete this address?',
          okText: 'Yes',
          cancelText: 'No',
          okType: 'danger',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (adminResponse) {
        setLoading(true);
        const deleteResponse = await deleteOrganizationAddress(id);
        if (deleteResponse.status) {
          toast.success(deleteResponse.message);
          let localAddresses = [...addresses];
          localAddresses = localAddresses.filter((item) => item._id != id);
          setAddresses(localAddresses);
        } else {
          toast.error(deleteResponse.message);
        }
      }
    } catch (err) {
      console.log("Error :", err);
      toast.error("Unable to delete address");
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const handlePODownloadClick = async () => {

    try {
      if (!purchaseOrder.purchaseOrderNumber) {
        toast.error(
          "Purchase order number is mandatory to use this functionality."
        );
        return;
      }
      if (purchaseOrder.purchaseOrderNumber && isChanged.poDocInfo) {
        toast.error("Please update order to use this functionality.");
        return;
      }
      setLoading(true);

      let data = {
        orderId: purchaseOrder?._id,
      };

      let response = await downloadPurchaseOrderPdf(data, token)
      console.log('Data ::', response.data);
      if (response.data && response.data.success) {
        const { signedUrl } = response.data;
        console.log("Signed URL :", signedUrl);
        setPdfModalInfo({
          show: true,
          fileName: `${purchaseOrder.pORefId}.pdf`,
          pdfUrl: signedUrl
        })
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err", err);
      toast.error(err.message);
    }
  };

  const handleChargeChange = (type, amount) => {
    setIsChanged({ ...isChanged, chargesChanged: true });
    let localTotal = purchaseOrder.supplierRfqOfferId.partsData.reduce(
      (accumulator, item) => {
        return accumulator + Number(item.qty) * Number(item?.price);
      },
      0
    );
    let orderAdjustMentValue =
      type == "adjustmentValue"
        ? Number(amount)
        : Number(
          purchaseOrder.adjustmentValue ? purchaseOrder.adjustmentValue : 0
        );
    setPurchaseOrder({
      ...purchaseOrder,
      totalAmount: (Number(localTotal) + orderAdjustMentValue).toFixed(2),
      adjustmentValue: orderAdjustMentValue,
    });

    localTotal = Number(localTotal) + orderAdjustMentValue;
  };
  const handleNewPoNumberSubmit = async () => {
    setLoading(true);
    try {
      const response = await updatePurchaseOrderNumber(token, {
        id: purchaseOrder._id,
        data: purchaseOrder.purchaseOrderNumber
      });
      setLoading(false);
      if (response && response.status) {
        setIsPoInfoChanged(false);
        setIsPoUpdated(true);

      }
      else {
        toast.error("Unable To Edit Name At The Moment");
      }


    } catch (error) {
      toast.error("Unable To Edit Po Number At The Moment");
    }
    finally {
      setLoading(false);


    }
  }

  console.log('purcahse Orders', purchaseOrder)

  return (
    <div
      className="admin-container"
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "#f4e6dd",
        minHeight: "100vh",
      }}
    >
      <Sidebar />
      <CaptchaModal
        showModal={showCaptchaModal}
        handleClose={handleCloseCaptchaModal}
        handleSendEmail={() => captchaCallback?.()}
        buttonText={buttonText}
      />
      <EmailModal
        show={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSubmit={(email) => {
          console.log("Selected/Entered Email:", email);
          setShowCaptchaModal(true);
          setButtonText('Send email');
          setCaptchaCallback(() => () => handleSendEmailConfirmationClick(email));
          setIsModalVisible(false)
        }}
        buttonText="Send"
        category="PO"
        emailList={selectedEmailListForSupplier}
      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
      />
      <GenericLoaderComponent
        isLoading={gobalLoading}
      />
      <EmailRecordModal
        show={showEmailRecord}
        handleClose={() => setShowEmailRecord(false)}
        emailRecords={purchaseOrder?.pOEmailRecord || []}
        setPdfModalInfo={setPdfModalInfo}
      />
      <span style={{ width: "100%" }}>
        <div className="center-heading">
          <h1 className="text-2xl font-bold mt-2">Purchase Orders Details</h1>
          <div className="right-container ">
            <Modal
              size="lg"
              dialogClassName="qoute-version-modal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showExpectedDateModal}
              onHide={() => setShowExpectedDateModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  style={{ fontSize: "15px" }}
                >
                  Expected Shipping Date Change Record
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ textAlign: "center" }}>
                  <br />
                  <div className="parts-table" style={{ fontSize: "14px" }}>
                    <div className="overflow-auto">
                      <table className="w-full table-auto border border-gray-300 text-xs">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-2 py-2 border border-gray-300 text-left">Updated On</th>
                            <th className="px-2 py-2 border border-gray-300 text-left">Expected Shipping Date</th>
                            <th className="px-2 py-2 border border-gray-300 text-left">Reason To Change</th>
                          </tr>
                        </thead>
                        <tbody>
                          {purchaseOrder?.expectedShippingDates?.length > 0 ? (
                            <>
                              <tr className="border border-gray-300">
                                <td className="px-2 py-2 border border-gray-300">
                                  {moment(
                                    purchaseOrder.poApprovedDate || purchaseOrder.createdAt
                                  ).format("DD MMM YYYY")}{" "}
                                  (Order creation date)
                                </td>
                                <td className="px-2 py-2 border border-gray-300">
                                  {purchaseOrder.poAcceptanceDate
                                    ? moment(purchaseOrder.poAcceptanceDate)
                                      .add(
                                        purchaseOrder?.supplierRfqOfferId?.leadTime,
                                        "days"
                                      )
                                      .format("DD MMM YYYY")
                                    : "NA"}
                                </td>
                                <td className="px-2 py-2 border border-gray-300">Original Promised Shipping Date</td>
                              </tr>
                              {purchaseOrder.expectedShippingDates.map((item, index) => (
                                <tr key={index} className="border border-gray-300">
                                  <td className="px-2 py-2 border border-gray-300">
                                    {moment(item.updatedDate).format("DD MMM YYYY h:mm A")}
                                  </td>
                                  <td className="px-2 py-2 border border-gray-300">
                                    {moment(item.updateValue).format("DD MMM YYYY")}
                                  </td>
                                  <td className="px-2 py-2 border border-gray-300">{item.reasonToChange}</td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr className="border border-gray-300">
                              <td className="px-2 py-2 border border-gray-300">
                                {moment(
                                  purchaseOrder.poApprovedDate || purchaseOrder.createdAt
                                ).format("DD MMM YYYY")}{" "}
                                (Order creation date)
                              </td>
                              <td className="px-2 py-2 border border-gray-300">
                                {purchaseOrder?.poAcceptanceDate
                                  ? moment(purchaseOrder.poAcceptanceDate)
                                    .add(
                                      purchaseOrder?.supplierRfqOfferId?.leadTime,
                                      "days"
                                    )
                                    .format("DD MMM YYYY")
                                  : ""}
                              </td>
                              <td className="px-2 py-2 border border-gray-300">Original Promised Shipping Date</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="white-btn"
                  style={{
                    backgroundColor: "#2B96DC",
                    color: "#fff",
                    border: "1px solid #2B96DC",
                  }}
                  onClick={() => setShowExpectedDateModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              size="lg"
              dialogClassName="qoute-version-modal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={esdModalForAcceptPO}
              onHide={handleCloseESDAcceptPOModal}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  style={{ fontSize: "15px" }}
                >
                  Please select the expected shipping date (ESD)
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ textAlign: "left" }}>
                  <p>
                    PSD:
                    {purchaseOrder?.poAcceptanceDate ? (
                      <>
                        {moment(purchaseOrder?.poAcceptanceDate)
                          .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                      </>
                    ) : (
                      <>
                        {moment(Date.now())
                          .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                      </>
                    )}
                  </p>
                  <h6>Select ESD : </h6>
                  <FormControl
                    type="date"
                    value={
                      expectedShippingDateSelected
                        ? expectedShippingDateSelected
                        : ""
                    }
                    onChange={(e) =>
                      setExpectedShippingDateSelected(e.target.value)
                    }
                    style={{ width: "300px" }}
                  />
                  <br />
                  {expectedShippingDateSelected &&
                    moment(Date.now())
                      .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                      .format("DD MMM YYYY") !=
                    moment(expectedShippingDateSelected).format("DD MMM YYYY") ? (
                    <>
                      <h6>Reason to change ESD : </h6>
                      <FormControl
                        type="text"
                        value={esdChangeReason}
                        onChange={(e) => setEsdChangeReason(e.target.value)}
                        placeholder="Enter reason to change ESD (100 character max)"
                        maxLength="100"
                      />
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please provide an explanation for the discrepancy
                        between the expected shipping date (
                        {moment(expectedShippingDateSelected).format("DD MMM YYYY")}
                        ) and the promised shipping date(
                        {moment(Date.now())
                          .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                        ).
                      </p>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="supplierButton"
                  onClick={() => {
                    handleProceedAcceptPOClick();
                  }}
                >
                  Proceed
                </Button>
                <Button
                  className="supplierButton"
                  onClick={handleCloseESDAcceptPOModal}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal centered show={showSentEmailModal} onHide={handleSentEmailModalOpenClose}>
              <Modal.Header closeButton>
                <Modal.Title>Select Emails</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group>
                    <Form.Label>Enter Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={manualEmail}
                      onChange={(e) => setManualEmail(e.target.value)}
                      placeholder="Enter email manually"
                    />
                    <Button className="my-2 bg-complementaryPrimaryColor !border-none" onClick={handleAddEmail}>
                      Send to entered email
                    </Button>
                  </Form.Group>
                  <hr />
                  <Form.Label>Select from List:</Form.Label>
                  {purchaseOrder?.supplierId?.emailList?.length >= 2 ? <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="default"
                          onChange={handleSelectAll}
                          checked={isSelectAllClicked}
                          indeterminate={
                            emailListToSend.length > 0 && emailListToSend.length < purchaseOrder?.supplierId?.emailList.length
                          }
                        />
                      }
                      label="Select All"
                    />
                  </FormGroup> : null}
                  {purchaseOrder?.supplierId?.emailList?.map((email, index) => (
                    <FormGroup>
                      <FormControlLabel control={<Checkbox color="default" onChange={() => handleCheckboxChange(email)} checked={emailListToSend.includes(email)} />} label={email} />
                    </FormGroup>
                  ))}
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={async () => {
                  if (emailListToSend.length == 0) {
                    await new Promise((resolve) => {
                      AntModal.error({
                        title: 'Error',
                        content: 'Please select at least one email',
                        zIndex: 1000,
                        onOk: () => resolve(),
                      });
                    });
                    return;
                  }
                  handleSentEmailModalOpenClose();
                }
                }>
                  Close
                </Button>
                <Button className="bg-complementaryPrimaryColor !border-none" onClick={() => handleSentEmailClickInModal()}>
                  Send to Selected Emails
                </Button>
              </Modal.Footer>
            </Modal>

            <PreviewAddressModal
              show={showModal}
              title="Organization shipping address"
              addresses={addresses}
              onHide={handleClose}
              onSelect={handleShippingAddressChange}
              onAddNew={() => {
                if (Array.isArray(addresses) && addresses.length >= 5) {
                  setShowModal(false);
                  setTimeout(() => {
                    toast.error('You can only add upto 5 Shipping address');
                  }, 300);
                  return;
                }
                setShowAddAddressModal(true)

              }}
              onDelete={handleDeleteAddress}
              context="SO_SHIPPING"
              type='organization shipping'
            />
            <GenericAddressComponent
              show={showAddAddressModal}
              setShow={setShowAddAddressModal}
              onAddFunction={addNewAddress}
              type={'organization shipping'}
            />

            <Modal
              size="sm"
              dialogClassName="qoute-version-modal"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={raiseIssueModal}
              onHide={handleRaiseIssueClose}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  style={{ fontSize: "15px" }}
                >
                  Raise an issue
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="raise-issue-div ">
                  <div className="progress-dots">
                    {/* +(raiseIssueStepCount===2)?'active':(raiseIssueStepCount>2)?"complete":"inactive" */}
                    <span
                      className={
                        raiseIssueStepCount === 0
                          ? "dot active"
                          : raiseIssueStepCount > 0
                            ? "dot complete"
                            : "dot inactive"
                      }
                    ></span>
                    <span
                      className={
                        raiseIssueStepCount === 1
                          ? "dot active"
                          : raiseIssueStepCount > 1
                            ? "dot complete"
                            : "dot inactive"
                      }
                    ></span>
                    <span
                      className={
                        raiseIssueStepCount === 2
                          ? "dot active"
                          : raiseIssueStepCount > 2
                            ? "dot complete"
                            : "dot inactive"
                      }
                    ></span>
                  </div>
                  <h5>
                    Step {`${raiseIssueStepCount + 1}`} of 3 :{" "}
                    {raiseIssueSteps[raiseIssueStepCount]}
                  </h5>
                  {raiseIssueStepCount === 0 ? (
                    <div className="raise-issue-part-div">
                      {partsWithIssue?.map((item, index) => {
                        return (
                          <div key={index} className="raise-issue-item">
                            <div className="price-box">
                              <div
                                className={
                                  item.selected ? "box-pr pr-checked" : "box-pr "
                                }
                                onClick={(e) =>
                                  handleSelectPartWithIssue(index)
                                }
                              >
                                <div className="pr-radio ">
                                  <label
                                    className="btn box-in !min-h-16"
                                    htmlFor="btnradio4"
                                  >
                                    <span className="triangle-0">
                                      <img src={tickwhite} />
                                    </span>
                                    <span className="item-name">
                                      {item.selectedPartFile?.filename
                                        ? item.selectedPartFile?.filename
                                        : item.selectedPartFile?.originalname
                                          ? item.selectedPartFile?.originalname
                                          : "Item Description (No file was uploaded):\n" +
                                          item.description}
                                    </span>
                                    <span className="qty-div">
                                      Qty:{item.qty}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className="raise-issue-check-div">
                        <div className="rd-left rd-box">
                          <input
                            type="checkbox"
                            id="testA"
                            name="radio-group"
                            checked={!isPartIssue}
                            onChange={handleNotPartIssueSelect}
                          />
                          <label htmlFor="testA">
                            Not a part issue. Purchase/ order related issue
                          </label>
                        </div>
                      </div>
                    </div>
                  ) : raiseIssueStepCount === 1 ? (
                    <div>
                      <div className="quality-related-issue">
                        <p className="text-bold text-xl my-1">
                          Quality related
                        </p>
                        {qualityRelatedIssue.length > 0
                          ? qualityRelatedIssue.map((item, index) => {
                            return (
                              <div key={index} className="raise-issue-item">
                                <div className="price-box">
                                  <div
                                    className={
                                      !item.selected
                                        ? "box-pr"
                                        : "box-pr pr-checked"
                                    }
                                    onClick={(e) =>
                                      handleQualityRelatedIssueSelect(index)
                                    }
                                  >
                                    <div className="pr-radio">
                                      <label
                                        className="btn box-in"
                                        htmlFor="btnradio4"
                                      >
                                        <span className="triangle-0">
                                          <img src={tickwhite} />
                                        </span>
                                        <span className="item-name">
                                          {item.name}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                          : null}
                      </div>

                      <div className="quality-related-issue">
                        <p className=" my-1">Purchase/Order related</p>
                        {orderRelatedIssue.length > 0
                          ? orderRelatedIssue.map((item, index) => {
                            return (
                              <div key={index} className="raise-issue-item">
                                <div className="price-box">
                                  <div
                                    className={
                                      !item.selected
                                        ? "box-pr"
                                        : "box-pr pr-checked"
                                    }
                                    onClick={(e) =>
                                      handlePORelatedIssueSelect(index)
                                    }
                                  >
                                    <div className="pr-radio">
                                      <label
                                        className="btn box-in"
                                        htmlFor="btnradio4"
                                      >
                                        <span className="triangle-0">
                                          <img src={tickwhite} />
                                        </span>
                                        <span className="item-name">
                                          {item.name}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                          : null}
                      </div>
                    </div>
                  ) : (
                    <div className="issue-description-div">
                      <div className="issue-description">
                        <textarea
                          placeholder="Write issue description here"
                          value={issueDescription}
                          onChange={(e) => setIssueDescription(e.target.value)}
                          className="!p-2"
                        />
                      </div>
                      <div className="downloadables">
                        <input
                          type="file"
                          id="BtnBrowseHidden"
                          name="files"
                          style={{ display: "none" }}
                          multiple
                          onChange={(e) => {
                            let filesForCheck = Array.from(e.target.files);
                            let isAllFilesValid = true;
                            filesForCheck.forEach(file => {
                              if (file.size > maxFileUploadSize) {
                                isAllFilesValid = false;
                              }
                            })

                            if (!isAllFilesValid) {
                              toast.error("File size should be less than 10 MB");
                              return;
                            }
                            handleIssueFileAttachmentAdd(e.target.files);
                          }}
                        />
                        <label htmlFor="BtnBrowseHidden" id="LblBrowse">
                          <p>+ Add Attachment</p>
                        </label>

                        {issueFileAttachment.length > 0
                          ? issueFileAttachment.map((item, i) => {
                            return (
                              <div key={i} className="issue-file-div">
                                {item.name}
                                <img
                                  src={closeImg}
                                  height="15px"
                                  onClick={() => {
                                    handleDeleteIssueAttachment(i);
                                  }}
                                />
                              </div>
                            );
                          })
                          : null}
                      </div>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="raise-issue-footer" style={{ width: "100%" }}>
                  <span
                    className="left-modal-footer underline text-primaryColor cursor-pointer"
                    onClick={() =>
                      (window.location = `mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`)
                    }
                  >
                    Contact Customer Service
                  </span>
                  <div>
                    <span className="mx-3 " onClick={handleRaiseIssueBack}>
                      Back
                    </span>
                    <div
                      onClick={async () => await handleRaiseIssueNext()}
                      className="req-quote-btn"
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      {raiseIssueStepCount === 2 ? "Submit" : "Next"}
                    </div>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
            <Modal
              size="lg"
              dialogClassName="esd-update-modal"
              aria-labelledby="change-esd-title"
              centered
              show={esdChangeModalVisible}
              onHide={handleCloseESDChangeModal}
            >
              <Modal.Header closeButton>
                <Modal.Title id="change-esd-title" style={{ fontSize: "15px" }}>
                  Update Expected Shipping Date (ESD)
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ textAlign: "left" }}>
                  <h6>Select New ESD:</h6>
                  <FormControl
                    type="date"
                    value={newExpectedShippingDate}
                    onChange={(e) => {
                      setIsNewEsdChanged(true);
                      setNewExpectedShippingDate(e.target.value)
                    }}
                    style={{ width: "300px" }}
                  />
                </div>
                {newExpectedShippingDate && isEsdChanged &&
                  moment(Date.now())
                    .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                    .format("DD MMM YYYY") !=
                  moment(newExpectedShippingDate).format("DD MMM YYYY") ? (
                  <>
                    <h6>Reason to change ESD : </h6>
                    <FormControl
                      type="text"
                      value={esdChangeReason}
                      onChange={(e) => setEsdChangeReason(e.target.value)}
                      placeholder="Enter reason to change ESD (100 character max)"
                      maxLength="100"
                    />
                    <p style={{ color: "red", fontSize: "12px" }}>
                      Please provide an explanation for the discrepancy
                      between the expected shipping date (
                      {moment(newExpectedShippingDate).format("DD MMM YYYY")}
                      ) and the promised shipping date(
                      {moment(Date.now())
                        .add(purchaseOrder?.supplierRfqOfferId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                      ).
                    </p>
                  </>
                ) : (
                  <></>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="supplierButton"
                  onClick={() => handleUpdateESD(newExpectedShippingDate)}
                  disabled={!newExpectedShippingDate}
                >
                  Proceed
                </Button>
                <Button
                  className="supplierButton"
                  onClick={handleCloseESDChangeModal}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>


            <Chat
              RefId={purchaseOrder.pORefId}
              open={open}
              onDrawerClose={onClose}
            />
            {purchaseOrder.pORefId && (
              <div className="order-container">
                <div
                  className="header"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  <Row>
                    <Col>
                      <div className="left-header">
                        <p>Organization shipping address:</p>
                        {purchaseOrder.shippingAddress ? (
                          <>
                            <div className="addressContainer">
                              <div className="name">
                                {purchaseOrder.shippingAddress.firstName}{" "}
                                {purchaseOrder.shippingAddress?.lastName || ""}
                              </div>

                              <div className="address">
                                {purchaseOrder.shippingAddress?.addressLineOne}
                                {purchaseOrder.shippingAddress
                                  ?.addressLinetwo ? (
                                  <div className="landMark">
                                    {
                                      purchaseOrder.shippingAddress
                                        ?.addressLinetwo
                                    }
                                  </div>
                                ) : null}

                                <div className="state">
                                  {purchaseOrder.shippingAddress?.city}{" "}
                                  {purchaseOrder.shippingAddress?.state}{" "}
                                </div>
                                <div className="postal-code">
                                  {purchaseOrder.shippingAddress?.postalCode}
                                </div>
                                <div className="country">
                                  {purchaseOrder.shippingAddress?.country}
                                </div>
                                <div className="mobile">
                                  {purchaseOrder.shippingAddress?.phoneNo
                                    ? `${purchaseOrder.shippingAddress?.dialCode
                                      ? `+${purchaseOrder.shippingAddress.dialCode}-`
                                      : ''
                                    }${purchaseOrder.shippingAddress.phoneNo}`
                                    : ''}
                                </div>

                              </div>
                            </div>
                          </>
                        ) : null}
                        <button
                          className="white-btn"
                          onClick={handleChangeAddress}
                        >
                          Change organization shipping address
                        </button>
                      </div>

                      <div className="left-header">
                        <p>Supplier Name:</p>
                        <h6>{purchaseOrder.supplierId?.companyName}</h6>

                        <p>PO Status :</p>

                        <h6>
                          {purchaseOrder.status == "Shipped"
                            ? purchaseOrder.status
                            : billsForPurchaseOrder.length > 0 &&
                              purchaseOrder.status == "Order Processing"
                              ? "Partially billed"
                              : purchaseOrder.status}
                        </h6>
                        {/* {purchaseOrder?.status} */}
                        {purchaseOrder?.poAcceptanceDate ? (
                          <>
                            <p>Acceptance Date :</p>
                            <h6>
                              {moment(purchaseOrder?.poAcceptanceDate).format(
                                "MMM DD, YYYY"
                              )}
                            </h6>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>
                    <Col>
                      <div className="right-header">
                        <p>Order Number:</p>
                        <h6 style={{ display: "inline", marginRight: "10px" }}>
                          #{purchaseOrder.pORefId}
                        </h6>
                      </div>
                      <div className="right-header">
                        <p>Project Name :</p>
                        <h6 style={{ display: "inline", marginRight: "10px" }}>
                          {purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.projectName ||
                            "Not Found"}
                        </h6>
                      </div>

                      <div className="right-header po-file-container">
                        <p>Process Type :</p>
                        <h6>
                          {purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.selectedProcess
                            ? processType[
                              purchaseOrder?.supplierRfqOfferId?.rfqOfferId
                                ?.selectedProcess - 1
                            ]?.name || "Unavailable"
                            : "Unavailable"}
                        </h6>

                        <p>PO Number :</p>
                        <h6 className="flex gap-x-2 items-center">
                          <FormControl
                            type="text"
                            // disabled={!isPoNumberEditing}
                            style={{ width: "300px" }}
                            ref={poInputRef}
                            onChange={(e) => {
                              // setIsChanged({ ...isChanged, poDocInfo: true });
                              setIsAnyUnsavedChange(true);
                              setIsPoInfoChanged(true);
                              setPurchaseOrder({
                                ...purchaseOrder,
                                purchaseOrderNumber: e.target.value,
                              });
                            }}
                            value={
                              purchaseOrder.purchaseOrderNumber
                                ? purchaseOrder.purchaseOrderNumber
                                : ""
                            }
                            placeholder="Enter PO Number"
                          />

                        </h6>

                        <p>PO Created At :</p>
                        <h6>
                          {purchaseOrder && purchaseOrder.status == "Draft" ? (
                            <>
                              {moment(purchaseOrder.createdAt).format(
                                "DD MMM YYYY"
                              )}
                            </>
                          ) : (
                            <>
                              {moment(
                                purchaseOrder.poApprovedDate ||
                                purchaseOrder.createdAt
                              ).format("DD MMM YYYY")}
                            </>
                          )}
                        </h6>
                      </div>
                    </Col>
                  </Row>
                  <Row>

                    <div className="left-header">
                      <p className="font-bold my-2">Admin Comments :</p>
                      <textarea
                        rows="3"
                        style={{ width: "100%" }}
                        placeholder="Enter comment here"
                        className="p-1"
                        value={purchaseOrder?.adminComment}
                        onChange={(e) => {
                          setIsChanged({ ...isChanged, adminComment: true });
                          setPurchaseOrder({
                            ...purchaseOrder,
                            adminComment: e.target.value,
                          });
                        }}
                      ></textarea>
                      <button
                        className="common-supplier-button"
                        style={{ marginBottom: "30px" }}
                        onClick={handleOrderAdminCommentUpdate}
                      >
                        Update Comment
                      </button>
                      <Link
                        to={`/admin/${purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.type == 'offer' ? 'offers' : 'rfq'}-details/${purchaseOrder?.supplierRfqOfferId?.rfqOfferId?._id}`
                        }
                        className="common-supplier-button hover:text-white"
                        style={{ marginBottom: "30px" }}
                      >
                        Go To {purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.type == 'offer' ? 'Offer' : 'RFQ'}
                      </Link>
                      <button
                        className="common-supplier-button"
                        style={{ marginBottom: "30px" }}
                        onClick={() => setShowExpectedDateModal(true)}
                      >
                        View ESD Record
                      </button>
                      <button
                        className="common-supplier-button"
                        style={{ marginBottom: "30px" }}
                        onClick={() => setShowEmailRecord(true)}
                      >
                        Show email record
                      </button>
                    </div>
                  </Row>
                </div>

                <Accordion>
                  <div className="grid-div or-details-row">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="req-box" ref={orderInformationRef}>
                          <h6>Order Information</h6>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body
                        style={{ background: "#edd8ca" }}
                        className="show-accordiion"
                      >
                        {isCreateBillActive ? (
                          <>
                            <div
                              className="bill-form-container"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="bill-form-row">
                                <div>
                                  <label htmlFor="billNumber">
                                    Enter Bill Number:
                                  </label>
                                  <Form.Control
                                    id="billNumber"
                                    type="text"
                                    value={supplierBillNumber}
                                    placeholder="Enter Bill Number"
                                    onChange={(e) =>
                                      setSupplierBillNumber(e.target.value)
                                    }
                                  />
                                </div>
                                <div>
                                  <label htmlFor="billDocument">
                                    Bill Document:
                                  </label>
                                  <br />
                                  {billDocument?.name ? (
                                    <div className="flex justify-center gap-x-2 items-center">
                                      <a
                                        className="downloadables"
                                        href={URL.createObjectURL(billDocument)}
                                        download={billDocument?.filename}
                                        target="_blank"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {billDocument?.name}
                                      </a>
                                      <a
                                        href={URL.createObjectURL(billDocument)}
                                        download={billDocument?.filename}
                                        target="_blank"
                                      >
                                        <DownloadIcon
                                          additionalClass={"text-primaryColor"}
                                        />
                                      </a>

                                      <div
                                        onClick={() => setBillDocument(null)}
                                      >
                                        <DeleteIcon
                                          additionalClasses={"text-red-500"}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <WithDragAndDrop
                                      additionalClassNames="!w-32 !h-7"
                                        // additionalClassNames="h-7   w px-4 text-sm rounded bg-white !text-primaryColor font-medium  border border-red-500 flex justify-center items-center"
                                        onFilesSelected={(e) => {
                                          let filesForCheck = Array.from(
                                            e.target.files
                                          );
                                          let isAllFilesValid = true;
                                          filesForCheck.forEach(file => {
                                            if (file.size > maxFileUploadSize) {
                                              isAllFilesValid = false;
                                            }
                                          })

                                          if (!isAllFilesValid) {
                                            toast.error("File size should be less than 10 MB");
                                            return;
                                          }

                                          setBillDocument(e.target.files[0]);
                                        }}

                                      >
                                        <label
                                          // className="bill-button"
                                          className="h-7   w-max px-4 text-sm rounded bg-white !text-primaryColor font-medium  border border-red-500 flex justify-center items-center "
                                          htmlFor={`upload-bill-doc`}
                                        >
                                          Upload Bill Document
                                        </label>
                                        <Form.Control
                                          id={`upload-bill-doc`}
                                          type="file"
                                          style={{ visibility: "hidden" }}
                                          onChange={(e) => {
                                            let filesForCheck = Array.from(
                                              e.target.files
                                            );
                                            let isAllFilesValid = true;
                                            filesForCheck.forEach(file => {
                                              if (file.size > maxFileUploadSize) {
                                                isAllFilesValid = false;
                                              }
                                            })

                                            if (!isAllFilesValid) {
                                              toast.error("File size should be less than 10 MB");
                                              return;
                                            }

                                            setBillDocument(e.target.files[0]);
                                          }}
                                        />
                                      </WithDragAndDrop>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {purchaseOrder.supplierRfqOfferId ? (
                          <div
                            className="table-container"
                            style={{
                              width: "100%",
                              overflowX: "auto",
                              padding: "10px",
                            }}
                          >
                            <table className="min-h-full" style={{ height: 'auto' }}>
                              <>
                                <thead>
                                  <tr className="heading-row">
                                    <th>Snapshot</th>
                                    <th>Part Description</th>
                                    <th>PO Qty</th>
                                    <th>Available Qty</th>
                                    <th>Bill Qty</th>
                                    <th>Price</th>
                                    <th>Amount</th>
                                    <th>Delete</th>
                                    <th>Edit</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {purchaseOrder.supplierRfqOfferId.partsData
                                    .length > 0 &&
                                    purchaseOrder.supplierRfqOfferId.partsData.map(
                                      (val, i) => {
                                        console.log("val in po ::", val);
                                        return (
                                          <tr key={i} style={{
                                            height: "200px"
                                          }} className=" ">
                                            <td
                                              style={{
                                                textAlign: "left",
                                                wordWrap: "break-word",
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                maxWidth: "200px",
                                              }}
                                              className=" "
                                            >
                                              <ThreeDViewerComponent
                                                item={val}
                                                additionalClasses={'border !border-0  '}
                                                selectedProcess={purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.selectedProcess}
                                              />

                                            </td>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                wordWrap: "break-word",
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                maxWidth: "150px",
                                              }}
                                            >
                                              {purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.selectedProcess >= 3 ? (
                                                <>
                                                  <textarea
                                                    style={{ width: "100%" }}
                                                    value={val?.description}
                                                    type="text"
                                                    placeholder="Enter Part Description"
                                                    onChange={(e) =>
                                                      handleItemFieldEdit(
                                                        e,
                                                        i,
                                                        "description"
                                                      )
                                                    }
                                                    disabled={
                                                      !isPartsEditable[i]
                                                    }
                                                    className="border p-1"
                                                  />
                                                </>
                                              ) : (
                                                <>
                                                  <div className="desc-part">
                                                    <textarea
                                                      style={{ width: "100%" }}
                                                      value={val?.description}
                                                      type="text"
                                                      placeholder="Enter Part Description"
                                                      onChange={(e) =>
                                                        handleItemFieldEdit(
                                                          e,
                                                          i,
                                                          "description"
                                                        )
                                                      }
                                                      disabled={
                                                        !isPartsEditable[i]
                                                      }
                                                      className="border p-1 min-w-[150px]"
                                                    />
                                                    {val?.selectedFile?.originalname ? <FileName
                                                      fileName={val?.selectedFile?.originalname}
                                                      onDownload={async () => {
                                                        const { originalname } = val?.selectedFile;
                                                        if (originalname && originalname.endsWith('.pdf')) {
                                                          const signedUrl = await getPresignedUrlForFile(val?.selectedFile.bucket, val?.selectedFile.key);
                                                          console.log('Signed URL for PDF:', signedUrl);
                                                          setPdfModalInfo({
                                                            show: true,
                                                            pdfUrl: signedUrl,
                                                            fileName: originalname,
                                                          });
                                                          return;
                                                        }
                                                        await downloadFileFromS3(val?.selectedFile)
                                                      }}
                                                    /> : null}
                                                    {
                                                      purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 1 ? <MetaDataInfoCncComponent
                                                        item={val}
                                                        fullMastersData={allCncMachineData}
                                                        allData={fullMastersData}
                                                        isEditEnabled={false}

                                                      /> : null
                                                    }
                                                    {
                                                      purchaseOrder?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 2 ? <MetaDataInfoThreeDComponent
                                                        item={val}
                                                        masterThreeDTechnologyData={masterThreeDTechnologyData}
                                                        isEditEnabled={false}

                                                      /> : null
                                                    }
                                                  </div>
                                                </>
                                              )}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              <input
                                                className="border p-1"
                                                value={val?.qty}
                                                style={{ width: "60px" }}
                                                type="number"
                                                onWheel={
                                                  numberInputOnWheelPreventChange
                                                }
                                                placeholder="Enter Quantity"
                                                onChange={(e) =>
                                                  handleItemFieldEdit(
                                                    e,
                                                    i,
                                                    "qty"
                                                  )
                                                }
                                                onKeyDown={(e) =>
                                                  ["e", "E", "+", "-"].includes(
                                                    e.key
                                                  ) && e.preventDefault()
                                                }
                                                disabled={!isPartsEditable[i]}
                                              ></input>{" "}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                              {" "}
                                              {availableQtyArr[val?._id]}
                                            </td>

                                            <td style={{ textAlign: "center" }}>
                                              <input
                                                className="border p-1"
                                                type="number"
                                                value={billPartsData[val?._id]}
                                                onWheel={
                                                  numberInputOnWheelPreventChange
                                                }
                                                placeholder="Bill Qty"
                                                onChange={(e) =>
                                                  handeBillItemChange(
                                                    e,
                                                    val?._id
                                                  )
                                                }
                                                onKeyDown={(e) =>
                                                  ["e", "E", "+", "-"].includes(
                                                    e.key
                                                  ) && e.preventDefault()
                                                }
                                                disabled={
                                                  !availableQtyArr[val?._id] ||
                                                  !isCreateBillActive
                                                }
                                                style={{ width: "60px" }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                className="border p-1"
                                                type="number"
                                                onWheel={
                                                  numberInputOnWheelPreventChange
                                                }
                                                placeholder="Enter item price"
                                                onChange={(e) =>
                                                  handleItemFieldEdit(
                                                    e,
                                                    i,
                                                    "price"
                                                  )
                                                }
                                                onKeyDown={(e) =>
                                                  ["e", "E", "+", "-"].includes(
                                                    e.key
                                                  ) && e.preventDefault()
                                                }
                                                value={val?.price}
                                                disabled={!isPartsEditable[i]}
                                                style={{ width: "60px" }}
                                              ></input>
                                            </td>
                                            <td>
                                              <p>
                                                {" "}
                                                {currencyFormatter(
                                                  Number(
                                                    val.qty * val.price
                                                  ).toFixed(2)
                                                )}
                                              </p>
                                            </td>
                                            <td>
                                              <div
                                                disabled={!isPartsEditable[i]}
                                                onClick={() => {
                                                  handleDeleteItemFromOrder(i)
                                                }
                                                }
                                              >
                                                <DeleteIcon
                                                  additionalClasses={` ${isPartsEditable[i]
                                                    ? "text-red-500"
                                                    : "text-gray-500"
                                                    } mx-auto h-5`}
                                                />
                                              </div>
                                            </td>

                                            <td>
                                              <Switch
                                                value={
                                                  isPartsEditable[i]
                                                    ? isPartsEditable[i]
                                                    : 0
                                                }
                                                onChange={() => {
                                                  handleEditableField(i);
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                              </>
                            </table>

                            <div className="total-amount-order flex font-bold mt-5 justify-end  w-full">
                              <h6 className="order-price">
                                Total Amount :{" "}
                                {currencyFormatter(
                                  Number(purchaseOrder.totalAmount).toFixed(2)
                                )}
                              </h6>
                            </div>
                          </div>
                        ) : null}
                      </Accordion.Body>
                    </Accordion.Item>
                  </div>


                  <div className="grid-div  or-details-row">
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        <div className="req-box">
                          <h6>Bills </h6>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body
                        style={{ background: "#edd8ca" }}
                        className="show-accordiion"
                      >
                        <div className="table-container">
                          <table>
                            <thead>
                              <tr>
                                <th>Bill Ref</th>
                                <th>Supplier Bill Number</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Sent Date</th>
                                <th>Shipping Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {billsForPurchaseOrder.length > 0 ? (
                                billsForPurchaseOrder?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <Link
                                          className="text-primaryColor"
                                          to={`/admin/bill-details/${item._id}`}
                                        >
                                          {item.billNumber}
                                        </Link>
                                      </td>
                                      <td>{item.supplierBillNumber}</td>
                                      <td>
                                        {currencyFormatter(
                                          item.billTotalAmount
                                        )}
                                      </td>
                                      <td>{capitalizedStatus(item.status)}</td>

                                      <td>
                                        {moment(item.createdAt).format(
                                          "MMM DD, YYYY"
                                        )}
                                      </td>

                                      <td>
                                        {item.shippedDate
                                          ? moment(item.shippedDate).format(
                                            "DD MMM YYYY"
                                          )
                                          : "NA"}
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <></>
                              )}
                            </tbody>
                          </table>
                          {billsForPurchaseOrder.length == 0 ? (
                            <>
                              <p
                                style={{
                                  width: "100%",
                                  textAlign: "center",
                                }}
                                className=" text-sm"
                              >
                                {" "}
                                No Bill is created for this purchase order.
                                Click on "Create New Bill" to create bill for
                                this purchase order.
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </div>

                  {purchaseOrder.isCompleted ? (
                    <>
                      <div className="grid-div  or-details-row">
                        <Accordion.Item eventKey="4">
                          <Accordion.Header>
                            <div className="req-box">
                              <h6> Feedback </h6>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body style={{ background: "#edd8ca" }}>
                            <>
                              <div className="pro-bar show-accordiion" >
                                <div
                                  className="pro-text"
                                  style={{ textAlign: "left" }}
                                >
                                  <h6>
                                    Share feedback here, this rating and
                                    feedback will be visible to supplier in
                                    supplier portal:
                                  </h6>
                                  <div >
                                    <div className="flex flex-wrap justify-between px-2 my-2">
                                      <div className="col">
                                        <h6>Quality</h6>
                                        <div className="flex my-2">
                                          <img
                                            src={
                                              purchaseOrder?.qualityRating >= 1
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(1, "qualityRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.qualityRating >= 2
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(2, "qualityRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.qualityRating >= 3
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(3, "qualityRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.qualityRating >= 4
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(4, "qualityRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.qualityRating >= 5
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(5, "qualityRating")
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <h6>Value for money</h6>
                                        <div className="flex my-2">
                                          <img
                                            src={
                                              purchaseOrder?.valueForMoneyRating >=
                                                1
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(
                                                1,
                                                "valueForMoneyRating"
                                              )
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.valueForMoneyRating >=
                                                2
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(
                                                2,
                                                "valueForMoneyRating"
                                              )
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.valueForMoneyRating >=
                                                3
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(
                                                3,
                                                "valueForMoneyRating"
                                              )
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.valueForMoneyRating >=
                                                4
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(
                                                4,
                                                "valueForMoneyRating"
                                              )
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.valueForMoneyRating >=
                                                5
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(
                                                5,
                                                "valueForMoneyRating"
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <h6>Overall Rating</h6>
                                        <div className="flex  my-2">
                                          <img
                                            src={
                                              purchaseOrder?.overAllRating >= 1
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(1, "overAllRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.overAllRating >= 2
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(2, "overAllRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.overAllRating >= 3
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(3, "overAllRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.overAllRating >= 4
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(4, "overAllRating")
                                            }
                                          />
                                          <img
                                            src={
                                              purchaseOrder?.overAllRating >= 5
                                                ? starsIcon
                                                : starsIconGrey
                                            }
                                            alt="rating"
                                            onClick={(e) =>
                                              handleRating(5, "overAllRating")
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col gap-4">
                                      <div>
                                        <h6 className="text-sm font-semibold text-gray-700 mb-1">Comment / Suggestions:</h6>
                                        <textarea
                                          className="w-full border border-gray-300 rounded-md p-3 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                                          rows="5"
                                          placeholder="Enter your feedback here..."
                                          value={purchaseOrder?.feedBackComment}
                                          onChange={(e) =>
                                            setPurchaseOrder({
                                              ...purchaseOrder,
                                              feedBackComment: e.target.value,
                                            })
                                          }
                                        />
                                      </div>

                                      <div className="flex justify-end">
                                        <button
                                          onClick={handleFeedBackSubmit}
                                          className="bg-primaryColor text-white px-5 py-2 rounded-md transition font-medium"
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </>
                          </Accordion.Body>
                        </Accordion.Item>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {Object.keys(orderIssue).length > 0 ? (
                    <div className="grid-div  or-details-row">
                      <Accordion.Item eventKey="6">
                        <Accordion.Header>
                          <div className="req-box">
                            <h6>Issues </h6>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body className="show-accordiion">
                          <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => {
                              setKey(k);
                              handleShowSelectedIssue(k);
                            }}
                            className="mb-3 qoute-version-tabs"
                          >
                            {allIssuesForOrder.map((item, i) => {
                              return (
                                <Tab
                                  eventKey={i}
                                  key={i}
                                  title={`Issues ${i + 1}`}
                                ></Tab>
                              );
                            })}
                          </Tabs>
                          {Object.keys(orderIssue).length > 0 && (
                            <div className="issue-div-admin">
                              <div className="issue-col-admin">
                                <h6>Issue Creation Date :</h6>
                                <p>
                                  {" "}
                                  {moment(orderIssue.createdAt).format(
                                    "DD MMM YYYY"
                                  )}
                                </p>
                              </div>
                              <div className="issue-col-admin">
                                <h6>Purchase Order Related Issues :</h6>
                                <ul>
                                  {orderIssue?.orderRelatedIssue?.length > 0 ? (
                                    orderIssue.orderRelatedIssue.map(
                                      (orderIssue, i) => {
                                        return (
                                          <li key={i}>{orderIssue?.name}</li>
                                        );
                                      }
                                    )
                                  ) : (
                                    <li>No Order related issue</li>
                                  )}
                                </ul>
                                <h6>Quality Related Issue :</h6>
                                <ul>
                                  {orderIssue?.qualityRelatedIssue?.length >
                                    0 ? (
                                    orderIssue.qualityRelatedIssue.map(
                                      (orderIssue, i) => {
                                        return (
                                          <li key={i}>{orderIssue.name}</li>
                                        );
                                      }
                                    )
                                  ) : (
                                    <li>No Quality related issue</li>
                                  )}
                                </ul>

                                <h6>Files attached :</h6>
                                <ul
                                  style={{
                                    width: "150px",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {orderIssue?.issueFileAttachment?.length >
                                    0 ? (
                                    orderIssue.issueFileAttachment.map(
                                      (fileAttached, i) => {
                                        return (
                                          <li
                                            key={i}
                                            onClick={async (e) => {
                                              console.log("fileAttached", fileAttached);
                                              e.stopPropagation();

                                            }}
                                          >
                                            <FileName
                                              fileName={fileAttached?.originalname}
                                              onDownload={async () => {
                                                const { originalname } = fileAttached;
                                                if (originalname && originalname.endsWith('.pdf')) {
                                                  const signedUrl = await getPresignedUrlForFile(fileAttached.bucket, fileAttached.key);
                                                  console.log('Signed URL for PDF:', signedUrl);
                                                  setPdfModalInfo({
                                                    show: true,
                                                    pdfUrl: signedUrl,
                                                    fileName: originalname,
                                                  });
                                                  return;
                                                }
                                                await downloadFileFromS3(fileAttached)
                                              }}
                                            />
                                          </li>
                                        );
                                      }
                                    )
                                  ) : (
                                    <li>No files attached</li>
                                  )}
                                </ul>
                              </div>

                              <div className="issue-col-admin">
                                <h6>Is Part Issue : </h6>
                                <p>
                                  {orderIssue.isPartIssue
                                    ? "It is a part related issue"
                                    : "Not a part related issue"}
                                </p>
                                <h6>Issue Description :</h6>
                                <div className="item-description">
                                  <p>{orderIssue.issueDescription}</p>
                                </div>
                                <h6>Issue status : </h6>
                                {orderIssue.isIssueClosed ? (
                                  <span>
                                    <p>Closed</p>
                                  </span>
                                ) : (
                                  <>
                                    <span>
                                      <p>Open</p>
                                    </span>
                                    <br />
                                    <button
                                      className="common-supplier-button"
                                      onClick={() => {
                                        setOrderIssue({
                                          ...orderIssue,
                                          isIssueClosed: true,
                                        });
                                        setPurchaseOrder({
                                          ...purchaseOrder,
                                          isCompleted: true,
                                        });
                                        setIsChanged({
                                          ...isChanged,
                                          isIssueClosed: true,
                                          deliveryDetails: true,
                                        });
                                      }}
                                    >
                                      Close Issue
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </div>
                  ) : null}
                </Accordion>
              </div>
            )}
            <div className="order-stage-div">
              {isCreateBillActive ? (
                <>
                  <button
                    className="supplier-stage-button"
                    onClick={handleCreateBill}
                  >
                    Create Bill
                  </button>
                  {!isBatchFileDownloading ? <button
                    className="supplier-stage-button"
                    onClick={async () => {
                      try {
                        setIsBatchFileDownloading(true);
                        const response = await downloadBatchFileSupplier(purchaseOrder?.supplierRfqOfferId?._id, 'supplier-rfq-offer');
                        const blob = new Blob([response], { type: 'application/zip' });
                        const downloadUrl = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `batch_download_${purchaseOrder.pORefId || ""}.zip`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(downloadUrl);

                      } catch (error) {
                        toast.error("Failed to download batch file at the moment");
                      } finally {
                        setIsBatchFileDownloading(false);
                      }

                    }
                    }
                  >
                    Batch download all technical drawings
                  </button> :
                    <button
                      className="supplier-stage-button flex items-center justify-center w-[300px]"
                    >
                      <LucidLoader />
                    </button>}

                  <button
                    className="supplier-stage-button"
                    onClick={handleCancelCreateBill}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="supplier-stage-button"
                    onClick={handleOrderUpdate}
                  >
                    Update Order
                  </button>
                  {!billsForPurchaseOrder.length && purchaseOrder.status != 'Cancelled' ? <button
                    className="supplier-stage-button"
                    onClick={() => setEsdChangeModalVisible(true)}
                  >
                    Change ESD
                  </button> : null}
                  {!isBatchFileDownloading ? <button
                    className="supplier-stage-button"
                    onClick={async () => {
                      try {
                        setIsBatchFileDownloading(true);
                        const response = await downloadBatchFileSupplier(purchaseOrder?.supplierRfqOfferId?._id, 'supplier-rfq-offer');
                        const blob = new Blob([response], { type: 'application/zip' });
                        const downloadUrl = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = `batch_download_${purchaseOrder.pORefId || ""}.zip`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(downloadUrl);

                      } catch (error) {
                        toast.error("Failed to download batch file at the moment");
                      } finally {
                        setIsBatchFileDownloading(false);
                      }

                    }
                    }
                  >
                    Batch download all technical drawings
                  </button> :
                    <button
                      className="supplier-stage-button flex items-center justify-center w-[300px]"
                    >
                      <LucidLoader />
                    </button>}

                  {purchaseOrder.status == "Draft" ? (
                    <>
                      {isPoUpdated ? <button
                        className="supplier-stage-button"
                        onClick={handleApprovePOClick}
                      >
                        Approve Final PO
                      </button> : null}
                      <button
                        className="supplier-stage-button"
                        onClick={handleDeleteOrderClick}
                      >
                        Delete Order
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="supplier-stage-button"
                        onClick={() => showDrawer(purchaseOrder.pORefId)}
                      >
                        <ChatButton
                          RefId={purchaseOrder.pORefId}
                          showDrawer={() => showDrawer(purchaseOrder.pORefId)}
                          additionalClass={
                            "!bg-[#DC712B] hover:!bg-complementaryHoverColor"
                          }
                        />
                      </button>

                      {isSendEmailInProgress ? (
                        <>
                          <button
                            className="supplier-stage-button 
                            !w-[189px] flex justify-center items-center"
                          // style={{ minWidth: "200px" }}
                          >
                            <LucidLoader additionalClass={'h-5'} />
                          </button>
                        </>
                      ) : (
                        <>
                          {purchaseOrder.status != 'Cancelled' ? <button
                            className="supplier-stage-button"
                            onClick={() => {
                              setIsModalVisible(true);
                            }}
                          >
                            Send Email Confirmation
                          </button> : null}
                        </>
                      )}
                      <button
                        className="supplier-stage-button"
                        onClick={handlePODownloadClick}
                      >
                        Download PO{" "}
                      </button>

                      {purchaseOrder.status != "Awaiting PO Acceptance" && purchaseOrder.status != 'Cancelled' &&
                        !purchaseOrder.isCompleted ? <button
                          className="supplier-stage-button"
                          onClick={handleCreateNewBillClick}
                        >
                        Create New Bill
                      </button> : null}
                      {purchaseOrder.status != "Awaiting PO Acceptance" && purchaseOrder.status != 'Cancelled' &&
                        !purchaseOrder.isCompleted ? <button
                          className="supplier-stage-button"
                          onClick={ErrorCheckHOF(() => {
                            setRaiseIssueModal(true);
                          })}
                        >
                        Raise Issue
                      </button> : null}

                      {purchaseOrder.status == "Awaiting PO Acceptance" &&
                        !purchaseOrder.isCompleted ? (
                        <>
                          <button
                            className="supplier-stage-button"
                            onClick={handleAcceptPOClick}
                          >
                            Accept PO For Supplier
                          </button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}

                  <button
                    className="supplier-stage-button"
                    onClick={async () => await handleBack()}
                  >
                    Back
                  </button>
                  {purchaseOrder.status != 'Cancelled' ? <button
                    className="supplier-stage-button"
                    onClick={handleCancelPurchaseOrder}
                  >
                    Cancel Order
                  </button> : null}
                </>
              )}
            </div>
          </div>
          {/* {loading && (
            <div className="fixed bg-white flex justify-center items-center opacity-80">
              <Loading />
            </div>
          )} */}
          <GenericLoaderComponent
            isLoading={loading}
          />
        </div>
      </span>
    </div >
  );
};

export default PurchaseOrderDetails;
